import React, {useEffect, useState} from 'react'
import '../css/admin.css'
import {
    campaignContractAddress, currentChainId,
    getCampaignContract,
    getPhetaTokenContract,
    Phase,
    phaseName,
    prettyPrintBigNumber
} from "../utils";
import {useWeb3React} from "@web3-react/core";
import {BigNumber} from "ethers";


export function AdminTable({updateHandler}) {
    const { active, account, library, connector, activate, setError, deactivate } = useWeb3React()
    // const [campaignContract, setCampaignContract] = useState<PhenomCampaign>()
    const [statistic, setStatistic] = useState({})
    const [publicRoundBalance, setPublicRoundBalance] = useState<BigNumber>()
    const [publicRoundSoldPheta, setPublicRoundSoldPheta] = useState<BigNumber>()
    const [publicRoundSoldUsd, setPublicRoundSoldUsd] = useState<BigNumber>()
    const [withdrawing, setWithdrawing] = useState(false)
    const [mobileShownPhaseStatistic, setMobileShownPhaseStatistic] = useState<string>()

    useEffect(() => {(async () => {
        const contract = await getCampaignContract(library)
        const vestingStartTime = await contract.vestingStartTime()
        // await setCampaignContract(contract)

        for (let phaseIndex = Phase.SEED; phaseIndex < Phase.PUBLIC; phaseIndex++) {
            const phase = phaseName(phaseIndex)
            setStatistic(prevState => {
                return {
                    ...prevState,
                    [phase]: {
                        ...prevState[phase],
                        phaseIndex: phaseIndex
                    }
                }
            })
            contract.getReleasedAmountByPhase(phaseIndex).then((released) => {
                setStatistic(prevState => {
                    return {
                        ...prevState,
                        [phase]: {
                            ...prevState[phase],
                            released: prettyPrintBigNumber(released)
                        }
                    }
                })
                contract.getAvailableAmountByPhase(phaseIndex).then((available) => {
                    setStatistic(prevState => {
                        return {
                            ...prevState,
                            [phase]: {
                                ...prevState[phase],
                                unlocked: prettyPrintBigNumber(available)
                            }
                        }
                    })
                })
            })

            contract.getInvestedAmountByPhase(phaseIndex).then((invested) => {
                setStatistic(prevState => {
                    return {
                        ...prevState,
                        [phase]: {
                            ...prevState[phase],
                            invested: prettyPrintBigNumber(invested)
                        }
                    }
                })
            })

            contract.getWithdrawableAmountByPhase(phaseIndex).then( async (withdrawable) => {
                const origin_withdrawable = withdrawable
                if (vestingStartTime.toNumber() === 0) {
                    // vesting not started yet
                    const preTgeTotal = await contract.preTgePurchaseTotals(phaseIndex)
                    withdrawable = withdrawable.sub(preTgeTotal)
                }
                setStatistic(prevState => {
                    return {
                        ...prevState,
                        [phase]: {
                            ...prevState[phase],
                            withdrawable: prettyPrintBigNumber(withdrawable),
                        }
                    }
                })
            })

            contract.getSupplyByPhase(phaseIndex).then( async (supply) => {
                setStatistic(prevState => {
                    return {
                        ...prevState,
                        [phase]: {
                            ...prevState[phase],
                            supply: prettyPrintBigNumber(supply)
                        }
                    }
                })
            })
        }

        const phetaContract = await getPhetaTokenContract(library)
        setPublicRoundBalance(await phetaContract.balanceOf(campaignContractAddress[currentChainId]))
        setPublicRoundSoldPheta(await contract.amountPhetaSoldInPublicRound())
        setPublicRoundSoldUsd(await contract.amountUsdSoldInPublicRound())
    })().then()}, [withdrawing, updateHandler])

    const withdraw = async (phaseIndex) => {
        setWithdrawing(true)
        try {
            const contract = await getCampaignContract(library)
            const tx = await contract.withdraw(phaseIndex, await contract.getWithdrawableAmountByPhase(phaseIndex))
            await tx.wait()
        } catch (e) {
            console.log(e)
        }
        setWithdrawing(false)
    }

    const withdrawPublic = async () => {
        setWithdrawing(true)
        try {
            const contract = await getCampaignContract(library)
            const tx = await contract.withdraw(Phase.PUBLIC, publicRoundBalance)
            await tx.wait()
        } catch (e) {
            console.log(e)
        }
        setWithdrawing(false)
    }

    return (
        <>
            <div className={'ap-table'}>
                <div className={'ap-table-titles'}>
                    <h6 className={'ap-table-title'}>supply</h6>
                    <h6 className={'ap-table-title'}>invested</h6>
                    <h6 className={'ap-table-title'}>unlocked</h6>
                    <h6 className={'ap-table-title'}>released</h6>
                    <h6 className={'ap-table-title'}>left</h6>
                </div>
                { Object.entries(statistic).map( ([key, data]) => (
                    <div key={key} className={'ap-table-line'}>
                        <h3 className={'ap-table-line-title ap-table-line-title-first'}>{key.substring(2)}</h3>
                        <p className={'ap-table-line-value'}>{data['supply']}</p>
                        <p className={'ap-table-line-value'}>{data['invested']}</p>
                        <p className={'ap-table-line-value'}>{data['unlocked']}</p>
                        <p className={'ap-table-line-value'}>{data['released']}</p>
                        <p className={'ap-table-line-value'}>{data['withdrawable']}</p>
                        { data['withdrawable'] == '0' || <a className={'ap-table-line-link'} onClick={() => withdraw(data['phaseIndex'])}>withdraw</a> }
                    </div>
                )) }

                {/*<div className={'ap-table-line'}>
                    <h3 className={'ap-table-line-title ap-table-line-title-second'}>private round</h3>
                    <p className={'ap-table-line-value'}>100000</p>
                    <p className={'ap-table-line-value'}>45678</p>
                    <p className={'ap-table-line-value'}>1234</p>
                    <p className={'ap-table-line-value'}>1234</p>
                    <p className={'ap-table-line-value'}>1234</p>
                    <a className={'ap-table-line-link'}>withdrow</a>
                </div>*/}
                <div className={'ap-table-titles'}>
                </div>
                <div className={'ap-table-line'}>
                    <h3 className={'ap-table-line-title ap-table-line-title-first'}>Public Round</h3>
                    <p className={'ap-table-line-value'}>
                        Sold: {prettyPrintBigNumber(publicRoundSoldPheta)} PHETA / {prettyPrintBigNumber(publicRoundSoldUsd)} USD
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Left: {publicRoundBalance !== undefined && prettyPrintBigNumber(publicRoundBalance)} PHETA
                    </p>
                    { publicRoundBalance && <a className={'ap-table-line-link'} onClick={withdrawPublic}>withdraw</a> }
                </div>
            </div>
            <div className={'ap-table-mobile'}>
                { Object.entries(statistic).map( ([key, data], index) => (
                    <>
                        <div className={'ap-tab-line-one'}>
                            <h3 className={'ap-tab-mob-line-one-title'}>{key.substring(2)}</h3>
                            <a onClick={() => {setMobileShownPhaseStatistic(key.substring(2))}}
                               className={'ap-tab-mob-line-one-link'}>information</a>
                            { data['withdrawable'] == '0' || <a className={'ap-tab-mob-line-link'} onClick={() => withdraw(data['phaseIndex'])}>withdraw</a> }
                        </div>
                        <div className={'ap-tab-info-one-container'} style={{top: `${63+index*29}px`}}>
                            <div className={`ap-tab-info-one ${mobileShownPhaseStatistic === key.substring(2) ? 'active' : ''}`}>
                                <div className={'ap-tab-info-container'}>
                                    <p className="ap-tab-info-text">Supply</p>
                                    <p className={'ap-tab-info-value'}>{data['supply']}</p>
                                </div>
                                <div className={'ap-tab-info-container'}>
                                    <p className="ap-tab-info-text">Invested</p>
                                    <p className={'ap-tab-info-value'}>{data['invested']}</p>
                                </div>
                                <div className={'ap-tab-info-container'}>
                                    <p className="ap-tab-info-text">Unlocked</p>
                                    <p className={'ap-tab-info-value'}>{data['unlocked']}</p>
                                </div>
                                <div className={'ap-tab-info-container'}>
                                    <p className="ap-tab-info-text">Released</p>
                                    <p className={'ap-tab-info-value'}>{data['released']}</p>
                                </div>
                                <div className={'ap-tab-info-container'}>
                                    <p className="ap-tab-info-text">Left</p>
                                    <p className={'ap-tab-info-value'}>{data['withdrawable']}</p>
                                </div>
                                <div className={'ap-tab-info-container'}>
                                    <button onClick={() => setMobileShownPhaseStatistic(undefined)}>Hide</button>
                                </div>
                            </div>
                        </div>
                    </>
                )) }
            </div>
        </>
    )
}














